var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page insert-page",class:[_vm.book.type]},[_c('transition',{attrs:{"name":"fade"}},[(_vm.status > 0)?_c('img',{attrs:{"src":_vm.image,"alt":"","draggable":"false"}}):_vm._e()]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }